import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import authService from '@/shared/services/AuthService';
import { injectStateService, StateService } from '@/shared/services/StateService';

class NavigateToState extends PureComponent {
  handleClick = () => {
    const { stateService, stateName, stateParams } = this.props;
    return stateService.gotoState(stateName, stateParams);
  };
  render() {
    const {
      functionality,
      permissions,
      children,
      title,
      useUrl,
      stateService,
      stateName,
      stateParams,
      paramsToJson,
      className,
    } = this.props;
    if (functionality !== null && !authService.hasPermission({ functionality, permissions }))
      return <span title={title}>{children}</span>; // No permission to go to state, return children

    const url = useUrl
      ? stateService.getStateUrl(stateName, paramsToJson ? { json: stateParams } : stateParams)
      : undefined;

    return (
      <a
        title={title}
        onClick={this.handleClick}
        href={url}
        className={classNames('nav2state', className)}
      >
        {children}
      </a>
    );
  }
}
NavigateToState.propTypes = {
  stateService: PropTypes.instanceOf(StateService).isRequired,
  stateName: PropTypes.string.isRequired,
  stateParams: PropTypes.shape({}),
  title: PropTypes.string,
  functionality: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  permissions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  useUrl: PropTypes.bool,
  paramsToJson: PropTypes.bool,
  className: PropTypes.string,
};
NavigateToState.defaultProps = {
  stateParams: undefined,
  title: undefined,
  functionality: null,
  permissions: 'read',
  children: null,
  useUrl: false,
  paramsToJson: false,
  className: null,
};

export default injectStateService(NavigateToState);
